<template>
  <div class="theme-search-area-options-list">
    <div v-if="label"><label>{{ label }}<template v-if="required">*</template></label></div>
    <div class="btn-group theme-search-area-options-list">
      <p-check
        v-model="modelField"
        class="p-default p-curve p-fill p-smooth"
        :name="name"
        :value="value"
        :checked="checked"
        color="primary">{{ valueLabel }}</p-check>
    </div>
    <span class="error-message-forms">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'label',
    'name',
    'submitted',
    'field',
    'value',
    'valueLabel',
    'required',
    'checked',
    'validate'
  ],
  watch: {
    'modelField' (data) {
      this.$emit('update:field', data)
    }
  },
  data () {
    return {
      modelField: this.field
    }
  }
};
</script>

<style scoped>
.pretty {
  line-height: 1.15;
}
</style>
